import { render, staticRenderFns } from "./ModalBulkService.vue?vue&type=template&id=0fc9be79&scoped=true&"
import script from "./ModalBulkService.vue?vue&type=script&lang=js&"
export * from "./ModalBulkService.vue?vue&type=script&lang=js&"
import style0 from "./ModalBulkService.vue?vue&type=style&index=0&id=0fc9be79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc9be79",
  null
  
)

export default component.exports